import React, { useState, useEffect } from "react";
import "../../styles/publication.css";

const Publication = () => {
  const [activePdf, setActivePdf] = useState("./padaipugal/jeeva-mulakkam.pdf");
  const [books, setBooks] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/home.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.books) {
          setBooks(data.books);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleBookClick = (pdfLink) => {
    setActivePdf(pdfLink);
  };

  return (
    <section className="publication-container">
      <h1 className="publication-title">படைப்புகள்</h1>
      <div className="publication-layout">
        <div className="book-list">
          {books.map((book) => (
            <div
              className={`book-item ${
                activePdf === book.pdfLink ? "active" : ""
              }`}
              key={book.id}
              onClick={() => handleBookClick(book.pdfLink)}
            >
              <div className="flip-book-container">
                <div className="flip-book">
                  <div className="page front">
                    <img
                      src={book.image}
                      alt={book.title}
                      className="book-image"
                    />
                  </div>
                  <div className="page middle">
                    <div className="page-content">
                      <p>{book.flipContent[0]}</p>
                    </div>
                  </div>
                  <div className="page back">
                    <div className="page-content">
                      <p>{book.flipContent[1]}</p>
                    </div>
                  </div>
                  <div className="page last">
                    <div className="page-content">
                      <p>{book.flipContent[2]}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="book-info">
                <h3 className="book-title">{book.title}</h3>
                <p className="book-description">{book.description}</p>
                <p className="readpub">
                  {" "}
                  <a
                    href={book.pdfLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="readpub1"
                  >
                    Read more
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="pdf-viewer1">
          {activePdf ? (
            <iframe
              src={activePdf}
              title="PDF Viewer"
              className="pdf-iframe"
              width="100%"
              height="100%"
            ></iframe>
          ) : (
            <div className="pdf-placeholder">
              <p>Click on a book to view its PDF</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Publication;
